<template>
  <div class="edit-routine-availability-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Edit Availability {{ formatDate(date) }}</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal"
                    aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <div class="box-body">
              <div class="box-row" v-if="!getSelected('TPD Assist')">
                <div class="box-col box-col-left">Location</div>
                <div class="box-col box-col-right d-flex">
                  <div class="w-100">
                    <el-select :popper-append-to-body="false" popper-class="search-specialty-popup" clearable filterable
                               class="w-100"
                               placeholder="Please choose" :class="hasError && !validateLocation ? 'is-invalid' : ''"
                               v-model="availability.Location.LocationID" @change="changeLocation">
                      <el-option v-for="(location, index) in locations" :value="location.id" :key="index"
                                 :label="location.fullLocation">{{ location.fullLocation }}
                      </el-option>
                    </el-select>
                    <div v-if="hasError && !validateLocation" class="text-danger">Location is required.</div>
                  </div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Select Service Type Allowed</div>
                <div class="box-col box-col-right">
                  <div class="w-75 px-3">
                    <img alt="" style="height: 52px" class="is-icon"
                         v-if="getBookingTypeDisplay('Independent Medical Examination')"
                         :src="getSelected('Independent Medical Examination') ? require('@/assets/images/ime_icon_active.svg') : require('@/assets/images/ime_icon.svg')"
                         @click="changeServiceType('Independent Medical Examination')" data-toggle="tooltip"
                         data-placement="right" title="Independent Medical Examination"/>
                    <img v-if="getBookingTypeDisplay('IME Plus')" alt="" style="height: 50px" class="is-icon pl-2"
                         :src="getSelected('IME Plus') ? require('@/assets/images/ime_plus_active.svg') : require('@/assets/images/ime_plus.svg')"
                         @click="changeServiceType('IME Plus')" data-toggle="tooltip" data-placement="right"
                         title="IME Plus"/>
                    <img v-if="getBookingTypeDisplay('Phone Call')" alt="" style="height: 50px" class="is-icon pl-2"
                         :src="getSelected('Phone Call') ? require('@/assets/images/phonecall_icon_active.svg') : require('@/assets/images/phonecall_icon.svg')"
                         @click="changeServiceType('Phone Call')" data-toggle="tooltip" data-placement="right"
                         title="Phone Call"/>
                    <img v-if="getBookingTypeDisplay('Court Matter')" alt="" style="height: 50px" class="is-icon pl-2"
                         :src="getSelected('Court Matter') ? require('@/assets/images/courtmatter_icon_active.svg') : require('@/assets/images/courtmatter_icon.svg')"
                         @click="changeServiceType('Court Matter')"
                         title="Court Matter"/>
                    <img v-if="getBookingTypeDisplay('Admin Only Booking')" alt="" style="height: 50px"
                         class="is-icon pl-2"
                         :src="getSelected('Admin Only Booking') ? require('@/assets/images/adminonly_icon_active.svg') : require('@/assets/images/adminonly_icon.svg')"
                         @click="changeServiceType('Admin Only Booking')"
                         title="Admin Only Booking"/>
                    <img v-if="getBookingTypeDisplay('Panel Assessment')" alt="" style="height: 50px"
                         class="is-icon pl-2"
                         :src="getSelected('Panel Assessment') ? require('@/assets/images/pannel_icon_active.svg') : require('@/assets/images/pannel_icon.svg')"
                         @click="changeServiceType('Panel Assessment')"
                         title="Panel Assessment"/>
                    <img v-if="getBookingTypeDisplay('TPD Assist')" alt="" style="height: 50px" class="is-icon pl-2"
                         :src="getSelected('TPD Assist') ? require('@/assets/images/tpd_icon_active.svg') : require('@/assets/images/tpd_icon.svg')"
                         @click="changeServiceType('TPD Assist')"
                         title="TPD Assist"/>
                  </div>
                  <div v-if="hasError && !validateServiceType" class="text-danger">Please select at least one service
                    type
                  </div>
                </div>
              </div>
              <div v-if="hideDeliveryType" class="box-row">
                <div class="box-col box-col-left">Select Delivery Method</div>
                <div class="box-col box-col-right d-flex">
                  <div class="w-50 px-5">
                    <img alt="" style="height: 25px" class="is-icon"
                         :src="getSelectedDelivery(2) ? require('@/assets/images/video_black_icon.svg') : require('@/assets/images/video_icon.svg')"
                         @click="changeDeliveryMethods(2)" data-toggle="tooltip" data-placement="right"
                         title="Virtual"/>
                    <img alt="" class="is-icon pl-3" style="height: 28px"
                         :src="getSelectedDelivery(1) ? require('@/assets/images/face2face_black.svg') : require('@/assets/images/face2face_inactive.svg')"
                         @click="changeDeliveryMethods(1)" data-toggle="tooltip" data-placement="right"
                         title="In-Person"/>
                  </div>
                  <div v-if="hasError && !validateDeliveryMethods" class="text-danger">Please select at least one
                    service type
                  </div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col w-25">Start Time</div>
                <div class="box-col w-25">
                  <vue-timepicker v-model="startTime"
                                  format="hh:mm A"
                                  class="w-100"
                                  :input-class="hasError && !validateStartTime ? 'is-invalid' : ''"
                                  input-class="form-control"
                                  :minute-interval="15"
                                  placeholder="HH:MM"></vue-timepicker>
                  <div v-if="hasError && !validateStartTime" class="text-danger">{{ startTimeMessage }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Appointment Duration</div>
                <div class="box-col box-col-right">
                  <el-input-number @change="changeVal" class="number-input" v-model="availability.Duration" :step="5"
                                   :min="5" :max="1000"></el-input-number>
                  <span class="ms-2">mins</span>
                  <div v-if="hasError && !validateStatus" class="text-danger">Duration is required.</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col w-25">Visibility Configuration</div>
                <div class="box-col w-25">
                   <span v-if="!getSelected('TPD Assist')">
                  <el-tooltip
                      v-if="!isFromSpecialistProps"
                      popper-class="body-tooltip"
                      :content="availability.AvailabilityOptions.ShowWorkCover ? 'Show to everyone INCLUDING WorkCover QLD' : 'Show to everyone EXCEPT WorkCover QLD'">
                    <img @click="changeShowWorkCover" class="is-icon" style="height: 26px"
                         :src="availability.AvailabilityOptions.ShowWorkCover ? require('./../assets/images/work_cover.svg') : require('./../assets/images/work_cover_gray.svg')"/>
                  </el-tooltip>
                  <el-tooltip
                      v-else
                      popper-class="body-tooltip"
                      :content="availability.AvailabilityOptions.ShowWorkCover ? 'Clicking this button will mean that WorkCover Queensland can not book this appointment' : 'Clicking this button will mean that WorkCover Queensland can book this appointment'">
                    <img @click="changeShowWorkCover" class="is-icon" style="height: 26px"
                         :src="availability.AvailabilityOptions.ShowWorkCover ? require('./../assets/images/work_cover.svg') : require('./../assets/images/work_cover_gray.svg')"/>
                  </el-tooltip>
                   </span>
                  <el-tooltip
                      popper-class="body-tooltip"
                      v-if="!isFromSpecialistProps"
                      :content="availability.AvailabilityOptions.ShowSpecificClients ? 'Show only to specific clients' : 'Show for all clients'">
                    <img @click="changeShowSpecificClients" class="is-icon ml-3" style="height: 26px"
                         :src="availability.AvailabilityOptions.ShowSpecificClients ? require('./../assets/images/specific_users.svg') : require('./../assets/images/specific_users_gray.svg')"/>
                  </el-tooltip>
                </div>
                <div class="box-col w-50">
                  <el-select :popper-append-to-body="false" clearable class="w-100"
                             v-show="availability.AvailabilityOptions.ShowSpecificClients"
                             v-model="availability.ClientIDs" multiple filterable @change="selectClients"
                             placeholder="Hide from everyone EXCEPT these specific clients">
                    <el-option v-for="item in clients" :key="item.id" :value="item.id"
                               :label="item.fullName"></el-option>
                  </el-select>
                  <div v-if="hasError && !validateClient" class="text-danger">Please select clients.</div>
                </div>
              </div>

              <div class="alert alert-danger hidden-element">
                <a class="close" title="close">×</a>
                <b>Error:</b> Please correct the errors shown above and try again.
              </div>

              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn @click="clickSave" dark>Save</v-btn>
                    <v-btn @click="deleteAvailability" dark>Delete</v-btn>
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-danger hidden-element edit-routine-alert">
      <a class="close" title="close">×</a>
      <b>Error:</b> {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'

export default {
  name: 'EditRoutineAvailabilityModal',
  props: ['availabilityProp', 'dataSourceProps', 'clients', 'locations', 'isFromSpecialistProps', 'specialistId', 'specialist'],
  components: {},
  data() {
    return {
      errorMessage: '',
      bookingTypes: [],
      dateRange: '',
      isBatchUpdate: false,
      loadModal: false,
      hasError: false,
      hasEndtimeError: false,
      hideButton: false,
      hideStartTime: false,
      hideEndTime: false,
      fillOrder: null,
      date: '',
      validateClient: true,
      startTime: '',
      startTimeMessage: '',
      endTimeMessage: '',
      fillOrders: [],
      availability: {},
      availabilities: [],
      specialistTimes: [],
      bookings: [],
      disabledDates: {
        ranges: [
          {
            from: window.moment(utilities.START_DATE, "YYYY-MM-DD"),
            to: window.moment().subtract(1, 'd'),
          },
          {
            from: window.moment(),
          }
        ],
      }
    }
  },

  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    hideDeliveryType() {
      return !!this.availability.ServiceTypes.find(x => utilities.bookingTypeWithDeliveryMethods(x.BookingTypeID));
    },
    validateServiceType() {
      return this.availability.ServiceTypes.length !== 0;
    },
    validateDeliveryMethods() {
      const arr = this.bookingTypes.filter(x => x.name === 'Independent Medical Examination' || x.name === 'IME Plus' || x.name === 'Panel Assessment')
      let count = 0
      this.availability.ServiceTypes.forEach(item => {
        if (arr.filter(x => x.id === item.BookingTypeID).length > 0) {
          count++
        }
      })
      if (count > 0) {
        return this.availability.DeliveryMethods.length > 0
      }
      return true
    },
    validDateRange() {
      if (this.isBatchUpdate && !this.dateRange) {
        return false
      }
      return true
    },
    validateLocation() {
      if (this.availability.LocationID == "") {
        return false
      }
      return true
    },
    validateDate() {
      if (this.date == "") {
        return false
      }
      return true
    },
    validateStatus() {
      if (this.availability.availabilityStatus == "") {
        return false
      }
      return true
    },
    validateStartTime() {
      if (this.availability.StartTime == "") {
        this.startTimeMessage = "Start time is required."
        return false
      }
      return true
    },
    validateEndTime() {
      if (this.availability.endTime == "") {
        this.endTimeMessage = "End time is required."
        return false
      } else if (moment(this.date + " " + this.availability.endTime, 'YYYY-MM-DD hh:mm A').isSameOrBefore(moment(this.date + " " + this.availability.startTime, 'YYYY-MM-DD hh:mm A'))) {
        this.endTimeMessage = 'End time cannot be before the start time.'
        return false
      }
      return true
    },
    validateOverlapTime() {
      if (this.checkOverlapTime(this.date, this.availability.startTime, this.availability.endTime)) {
        return false
      }
      return true
    },
    validateExistingBookingTime() {
      if (this.checkExistingBookingTime(this.date, this.availability)) {
        return false
      }
      return true
    },
  },
  methods: {
    getBookingTypeDisplay(name) {
      return this.specialist.PerformedServices.find(item => item.BookingTypeName === name)
    },
    getSelected(v) {
      const type = this.bookingTypes.find(type => type.name === v);
      if (type) {
        const selected = this.availability.ServiceTypes.find(x => x.BookingTypeID === type.id);
        return !!selected
      }
      return false
    },
    changeServiceType(v) {
      const type = this.bookingTypes.find(type => type.name === v);
      if (type) {
        const index = this.availability.ServiceTypes.findIndex(x => x.BookingTypeID === type.id)
        if (index > -1) {
          this.availability.ServiceTypes.splice(index, 1)
        } else {
          if (type.id === 19) {
            this.availability.Location.LocationID = 0
            this.availability.ServiceTypes = []
            if (this.availability.Options) {
              this.availability.Options.ShowWorkCover = 0
            }
            this.availability.DeliveryMethods = []
          } else {
            const tpdIndex = this.availability.ServiceTypes.findIndex(x => x.BookingTypeID === 19)
            if (tpdIndex > -1) {
              this.availability.ServiceTypes = []
            }
          }
          this.availability.ServiceTypes.push({
            BookingTypeID: type.id
          })
        }
      }
    },
    getSelectedDelivery(v) {
      const selected = this.availability.DeliveryMethods.find(x => x.DeliveryMethodID === v);
      return !!selected
    },
    changeDeliveryMethods(v) {
      const index = this.availability.DeliveryMethods.findIndex(x => x.DeliveryMethodID === v)
      if (index > -1) {
        this.availability.DeliveryMethods.splice(index, 1)
      } else {
        this.availability.DeliveryMethods.push({
          DeliveryMethodID: v
        })
      }
    },
    selectClients(v) {
      this.$forceUpdate()
      if (v && v.length > 0) this.validateClient = true
    },
    changeVal() {
      this.$forceUpdate()
    },
    changeShowWorkCover() {
      if (this.availability.AvailabilityOptions.ShowWorkCover) {
        this.availability.AvailabilityOptions.ShowWorkCover = 0
      } else {
        this.availability.AvailabilityOptions.ShowWorkCover = 1
      }
    },
    changeShowSpecificClients() {
      if (this.availability.AvailabilityOptions.ShowSpecificClients) {
        this.availability.AvailabilityOptions.ShowSpecificClients = 0
        this.availability.ClientIDs = []
      } else {
        this.availability.AvailabilityOptions.ShowSpecificClients = 1
      }
    },
    handleModal(e) {
      this.loadModal = !this.loadModal
      if (this.loadModal) {
        $('html').addClass('modal-mask-open')
      } else {
        $('html').removeClass('modal-mask-open')
      }
    },
    formatDate(date) {
      return utilities.formatDate(date, "DD/MM/YYYY")
    },
    checkOverlapTime(date, startTime, endTime) {
      var result = false
      var range1 = null
      var range2 = null
      for (var i = 0; i < this.availabilities.length; i++) {
        range1 = moment.range(utilities.formatDate(date + " " + startTime, "YYYY-MM-DD HH:mm"), utilities.formatDate(date + " " + endTime, "YYYY-MM-DD HH:mm"))
        range2 = moment.range(utilities.formatDate(date + " " + this.availabilities[i].startTime, "YYYY-MM-DD HH:mm"), utilities.formatDate(date + " " + this.availabilities[i].endTime, "YYYY-MM-DD HH:mm"))
        if (range1.overlaps(range2)) {
          result = true
          break
        }
      }
      return result
    },
    checkExistingBookingTime(date, availabilty) {
      var result = false
      // Get last booking on the list
      var booking = this.bookings.filter(x => x.bookingDetails.specialistAvailabilityId == availabilty.id).pop()
      if (booking) {
        var bookingStartTime = utilities.formatDate(booking.bookingDetails.dateTime, "YYYY-MM-DD HH:mm")
        var bookingEndTime = utilities.formatDate(utilities.formatDate(booking.bookingDetails.dateTime, "YYYY-MM-DD") + " " + booking.bookingDetails.endTime, "YYYY-MM-DD HH:mm")
        var startTime = utilities.formatDate(date + " " + availabilty.startTime, "YYYY-MM-DD HH:mm")
        var endTime = utilities.formatDate(date + " " + availabilty.endTime, "YYYY-MM-DD HH:mm")
        if (availabilty.startTime != '' && availabilty.endTime != '' && (moment(startTime, "YYYY-MM-DD HH:mm").isAfter(bookingStartTime, "YYYY-MM-DD HH:mm") || moment(endTime, "YYYY-MM-DD HH:mm").isBefore(bookingEndTime))) {
          result = true
        }
      }
      return result
    },
    changeStartTime() {
      // if (this.availability.numberTimeSlotsBooked > 0) {
      //
      // }
    },
    changeEndTime() {
      // this.hasEndtimeError = false
      // if (moment(this.availability.startTime, 'hh:mm A').isSameOrAfter(moment(this.availability.endTime, 'hh:mm A'))) {
      //   this.hasEndtimeError = true
      //   this.endTimeMessage = 'End time cannot be before the start time!'
      // }
    },
    setAvailability(item) {
      this.availability = _.cloneDeep(item)
      let time = window.moment(this.availability.StartTime, 'HH:mm').format('hh:mm A')
      this.startTime = time
      this.availability.Duration = window.moment(this.availability.EndTime, 'HH:mm').diff(window.moment(this.availability.StartTime, 'HH:mm'), 'minute')
      this.availability.ClientIDs = this.availability.SpecificClients ? this.availability.SpecificClients.map(item => item.ClientID) : []
    },

    async clickSave() {
      this.$forceUpdate()
      if (!this.validateStartTime || !this.validateEndTime || !this.validateOverlapTime || !this.validateExistingBookingTime || !this.validDateRange || !this.validateServiceType || !this.validateDeliveryMethods) {
        this.hasError = true
        utilities.showAlert(".edit-routine-availability-modal .alert-danger")
        return
      } else {
        if (this.availability.AvailabilityOptions.ShowSpecificClients && (!this.availability.ClientIDs || this.availability.ClientIDs.length === 0)) {
          this.validateClient = false
          this.hasError = true
          return
        }
      }
      this.hasError = false
      this.validateClient = true
      const param = {
        UsernameLog: this.user.name,
        UserIDLog: this.user.id,
        LocationID: this.availability.Location.LocationID, // Integer
        StartTime: utilities.formatDate(this.startTime, "HH:mm:ss", "hh:mm A"), // Time String
        Duration: this.availability.Duration, // Integer
        Options: {
          ShowWorkCover: this.availability.AvailabilityOptions.ShowWorkCover ? 1 : 0, // Integer 0-False, 1-True,
          ShowSpecificClients: this.availability.AvailabilityOptions.ShowSpecificClients ? 1 : 0, // Integer 0-False, 1-True,
        },
        ServiceTypes: this.availability.ServiceTypes.map(item => {
          return {
            BookingTypeID: item.BookingTypeID
          }
        })
      }
      if(this.availability.DeliveryMethods) {
        param.DeliveryMethods = this.availability.DeliveryMethods
      }
      if (this.availability.ClientIDs.length > 0) {
        param.ClientIDs = this.availability.ClientIDs
      }
      if (this.isBatchUpdate) {
        const start = window.moment(this.dateRange[0])
        const end = window.moment(this.dateRange[1])
        let idsArr = []
        this.dataSourceProps.forEach(item => {
          if (window.moment(item.date).add(1, 'hour').isBetween(window.moment(start), window.moment(end).endOf('day'))) {
            const idArr = item.Availabilities.map(a => a.AvailabilityID)
            idsArr.concat(idArr)
          }
        })
      }
      await this.$store.dispatch('loading/setLoadComponent', true)
      if (this.availability.BookingStatus === 'B') {
        const obj = {
          specialistId: this.specialistId,
          startDate: this.availability.date,
          endDate: this.availability.date
        }
        const bookings = await utilities.getSpecialistBookings(obj)
        const booking = bookings.find(item => item.bookingDetails.AvailabilityID === this.availability.AvailabilityID)
        if (booking) {
          let result = true
          if (!result) {
            this.errorMessage = 'Please update booking type before you edit availability type.'
            utilities.showAlert('.edit-routine-alert')
            await this.$store.dispatch('loading/setLoadComponent', false)
            return
          }
        }
      }
      await utilities.putAvailability(this.availability.AvailabilityID, param, (id) => {
        if (id) {
          this.$parent.successMessage = 'Availability updated successfully.'
          utilities.showAlert('.year-calendar .alert-success')
          this.$parent.reload()
          this.$store.dispatch('loading/setLoadComponent', false)
          this.handleModal()
        }
      })
    },

    async deleteAvailability() {
      console.log(this.availability)
      this.$store.dispatch('loading/setLoadComponent', true)
      var result = await utilities.deleteAvailability(this.availability.AvailabilityID)
      if (result) {
        this.$parent.successMessage = 'Availability successfully deleted.'
        utilities.showAlert('.year-calendar .alert-success')
        this.handleModal()
        setTimeout(() => {
          this.$parent.reload()
        }, 1000)
      }
      this.$store.dispatch('loading/setLoadComponent', false)
    },

    changeLocation(e) {
      var location = this.locations.find(x => x.id === Number(e))
      this.availability.locationName = location.name
      this.availability.cityName = location.cityName
    },

    async loadData() {
      this.bookingTypes = await utilities.getBookingTypes()
    }
  },
  beforeMount() {
  },
  updated() {
  },
}
</script>
